/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadEducationProgramImageReferenceData$Params {
  educationProgramId: string;
  id: string;
      body?: {
'file'?: Blob;
}
}

export function uploadEducationProgramImageReferenceData(http: HttpClient, rootUrl: string, params: UploadEducationProgramImageReferenceData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, uploadEducationProgramImageReferenceData.PATH, 'post');
  if (params) {
    rb.path('educationProgramId', params.educationProgramId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

uploadEducationProgramImageReferenceData.PATH = '/educationprogram/{educationProgramId}/images/{id}/data';
